// Einbettung als Reiter im Bitrix-Deal (seit 25.10.2026). Der Reiter-Weg
// (api/_lib/dokumentenAssistentReiter.js) leitet nach
//   /?view=vertraege-am-dokumenten-assistent&einbettung=bitrix&dealId=12345
// weiter. Dann zeigt die App nur diese Ansicht, fest auf den Deal des Reiters: keine
// Navigation, keine Handy-Oberflaeche (der Rahmen in Bitrix ist oft schmaler als 720 px) und
// keine Umleitung zur Bitrix-Verbindungsseite (die laesst sich nicht im Rahmen oeffnen).
// Ein Test im Server (dokumentenAssistentReiter.test.js) haelt Ansicht und Parameter gleich.

export const EINBETTUNG_PARAMETER = 'einbettung';
export const EINBETTUNG_BITRIX = 'bitrix';
export const EINGEBETTETE_ANSICHTEN = new Set(['vertraege-am-dokumenten-assistent']);

const KEINE_EINBETTUNG = Object.freeze({ aktiv: false, ansicht: '', dealId: '' });

/** Liest die Einbettung aus der Adresse (window.location.search). */
export function leseEinbettung(suche) {
  let parameter;
  try {
    parameter = new URLSearchParams(String(suche || ''));
  } catch (fehler) {
    return KEINE_EINBETTUNG;
  }
  if (parameter.get(EINBETTUNG_PARAMETER) !== EINBETTUNG_BITRIX) return KEINE_EINBETTUNG;
  const ansicht = String(parameter.get('view') || '').trim().toLowerCase();
  if (!EINGEBETTETE_ANSICHTEN.has(ansicht)) return KEINE_EINBETTUNG;
  const dealId = String(parameter.get('dealId') || '').trim();
  return { aktiv: true, ansicht, dealId: /^[1-9]\d{0,11}$/.test(dealId) ? dealId : '' };
}

// Bitrix schickt die Deal-ID nur aus dem Deal (Reiter oder Menue "Anwendungen" im Deal), nicht
// aus dem Anwendungsmenue links (26.10.2026). Dann steht der Deal nicht fest, und das sagt dieser Satz.
export const OHNE_DEAL_HINWEIS = 'Ohne Deal geöffnet. Im Deal steht der Assistent als Reiter „Dokumenten-Assistent“ '
  + 'und im Menü „Anwendungen“ – von dort geöffnet, ist der Deal schon eingetragen. Hier die Deal-ID eingeben.';

/** Dieselbe Ansicht im vollen Tool, ausserhalb von Bitrix (neuer Tab). */
export function adresseImTool(ansicht) {
  return `/?${new URLSearchParams({ view: ansicht }).toString()}`;
}

// Anmeldung aus Bitrix (seit 25.10.2026, wie beim Lageplan-Tool, nur fuer Admins): Der Reiter
// gibt das Kennwort einer Sitzung im Fragment mit (#bx=…), sonst den Grund (#bx-grund=…). Die
// Ansicht schickt es als Kopf an den Dokumenten-Assistenten (api/_lib/bitrixSitzung.js).
export const BITRIX_SITZUNG_KOPF = 'x-bitrix-session';
const SITZUNG_SPEICHER = 'enpower.bitrixSitzung.v1';
const KENNWORT = /^[a-f0-9]{64}$/;

const ANMELDE_HINWEISE = {
  kein_admin: 'Der Dokumenten-Assistent im Deal ist nur für Admins.',
  abgelaufen: 'Die Anmeldung über Bitrix ist abgelaufen. Bitte den Reiter im Deal neu öffnen oder hier anmelden.',
};

/** Hinweis über dem Login, wenn die Anmeldung aus Bitrix nicht geklappt hat. */
export function anmeldeHinweis(grund) {
  if (!grund) return '';
  return ANMELDE_HINWEISE[grund] || 'Die automatische Anmeldung über Bitrix hat nicht geklappt. Bitte hier anmelden.';
}

/** #bx=<Kennwort> bzw. #bx-grund=<Grund> aus dem Fragment - alles andere gilt als leer. */
export function leseAnmeldungAusFragment(fragment) {
  const parameter = new URLSearchParams(String(fragment || '').replace(/^#/, ''));
  const kennwort = String(parameter.get('bx') || '').trim();
  const grund = String(parameter.get('bx-grund') || '').trim();
  return {
    kennwort: KENNWORT.test(kennwort) ? kennwort : '',
    grund: /^[a-z_]{1,40}$/.test(grund) ? grund : '',
  };
}

/**
 * Nimmt die Anmeldung aus der Adresse und raeumt das Fragment sofort weg (das Kennwort soll
 * nicht in Verlauf oder Lesezeichen bleiben). Gemerkt wird sie fuer Neuladen im selben Tab;
 * ohne Fragment gilt die gemerkte. Meldet Bitrix einen Grund, wird die gemerkte vergessen.
 */
export function nimmBitrixAnmeldung(fenster) {
  const hash = String(fenster?.location?.hash || '');
  let ergebnis = leseAnmeldungAusFragment(hash);
  if (/(^#|&)bx(-grund)?=/.test(hash)) {
    try {
      fenster.history.replaceState(null, '', `${fenster.location.pathname}${fenster.location.search}`);
    } catch (fehler) {
      /* Adresse bleibt - die Anmeldung gilt trotzdem */
    }
  }
  try {
    if (ergebnis.kennwort) {
      fenster.sessionStorage.setItem(SITZUNG_SPEICHER, ergebnis.kennwort);
    } else if (ergebnis.grund) {
      fenster.sessionStorage.removeItem(SITZUNG_SPEICHER);
    } else {
      const gemerkt = String(fenster.sessionStorage.getItem(SITZUNG_SPEICHER) || '');
      if (KENNWORT.test(gemerkt)) ergebnis = { kennwort: gemerkt, grund: '' };
    }
  } catch (fehler) {
    /* Speicher gesperrt: dann gilt die Anmeldung nur bis zum Neuladen */
  }
  return ergebnis;
}

export function vergissBitrixSitzung(fenster) {
  try {
    fenster.sessionStorage.removeItem(SITZUNG_SPEICHER);
  } catch (fehler) {
    /* nichts zu vergessen */
  }
}
